import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnChanges, OnInit } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';

import {
  ChatChannelListComponent,
  ChatInChatSelectedComponent,
} from '@offconon/shared/features/chat/chat-channel-list';
import { ContactsRightPanelRenderComponent } from '@offconon/shared/ui/contacts-module/contacts-right-panel-render';
import { SharedTaskWorkgroupPanelComponent } from '@offconon/shared/ui/design-helper/shared-task-workgroup-panel';
import { EmailAccountsContentRightPanelRenderComponent } from '@offconon/shared/ui/email-module/email-module/render/email-accounts-content-right-panel-render';
import { NotesRightPanelRenderComponent } from '@offconon/shared/ui/notes-module/notes-right-panel-render';
import { TasksRightPanelRenderComponent } from '@offconon/shared/ui/task-manager-module/tasks-right-panel-render';
import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';
import { getSelectedBusiness } from '@offconon/workroom/store/business';

import { ChatNewMessageErpComponent } from '../chat-new-message-erp/chat-new-message-erp.component';

@Component({
  selector: 'offconon-erp-module-selector',
  imports: [
    CommonModule,
    ChatChannelListComponent,
    TabsModule,
    TranslateModule,
    ChatInChatSelectedComponent,
    TasksRightPanelRenderComponent,
    ContactsRightPanelRenderComponent,
    EmailAccountsContentRightPanelRenderComponent,
    SharedTaskWorkgroupPanelComponent,
    NotesRightPanelRenderComponent,
    ChatNewMessageErpComponent,
  ],
  templateUrl: './erp-module-selector.component.html',
  styles: ``,
})
export class ErpModuleSelectorComponent implements OnInit, OnChanges {
  @Input() chat_view_type: any;
  @Input() selected_module = 'chatlist';
  @Input() workgroup_menu = false;
  @Input() used_module: any;

  private store = inject(Store);
  private designPanelsHelperService = inject(DesignPanelsHelperService);
  private destroyRef = inject(DestroyRef);

  selectedBusiness = toSignal(this.store.select(getSelectedBusiness));

  parameters = {};

  ngOnChanges(): void {
    this.designPanelsHelperService.setSelectedChatRoomIdDelivery(null);
    this.designPanelsHelperService.setSelectedChatRoomId(null);

    this.selectedModule(this.selected_module);
  }

  ngOnInit() {
    this.parameters = {
      view_type: this.chat_view_type ? this.chat_view_type : 'widget',
      service_id: this.selectedBusiness()?.business_co_worker_id,
      selectedBusiness: this.selectedBusiness(),
    };

    this.designPanelsHelperService.selectedModuleEnum$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (postData: any) => {
          if (postData !== null) {
            this.selected_module = postData;
            this.selectedModule(this.selected_module);
          }
        },
      });

    this.designPanelsHelperService.selectedChatRoomId$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (postData: any) => {
          if (postData !== null) {
            this.designPanelsHelperService.setSelectedChatRoomIdDelivery(Number(postData));
            this.selected_module = 'chatroom';

            this.selectedModule(this.selected_module);
          }
        },
      });
    this.selectedModule(this.selected_module);
  }
  selectedModule(modulename: any) {
    this.selected_module = modulename;
  }

  selectedChatRoomId(roomId: number): void {
    this.designPanelsHelperService.setSelectedChatRoomId(roomId);
  }
}
